const holder = {
  closeCategorySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false, displayAdditionalCategories: false });
      document.removeEventListener("mousedown", holder.closeCategorySelector)
    }
  }
};

export default {
  'CategoryInput.Selector': ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter
    holder.containerRef = containerRef
    internalStateSetter({ isOpen: !isOpen });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeCategorySelector);
    } else {
      document.addEventListener("mousedown", holder.closeCategorySelector);
    }
  },
  'CategoryInput.Body.SearchInput': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ searchValue: value })
  },
  'CategoryInput.Body.SelectedCategoryRow': ({ }, _, internalStateSetter) => {
    internalStateSetter({ isOpen: false });
  },
  'CategoryInput.Body.ClassifiedCategoryRow': ({ category }, outlet, internalStateSetter) => {
    outlet({ selectedCategoryId: category.id });
    internalStateSetter({ isOpen: false, displayAdditionalCategories: false });
  },
  'CategoryInput.Body.AdditionalCategoriesButton': ({ }, _, internalStateSetter) => {
    internalStateSetter({ displayAdditionalCategories: true })
  },
  'CategoryInput.Body.Categories.CategoryRow': ({ category }, outlet, internalStateSetter) => {
    outlet({ selectedCategoryId: category.id });
    internalStateSetter({ isOpen: false, displayAdditionalCategories: false });
  },
}